import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionKind } from "../../types";
import { SessionDraft } from "../types";
import { sessionToDraft } from "../editMapping";
import { buildEditionPayload } from "../../editionPayload";

export interface SessionWizardEdition {
  lo_id?: number;
  learning_objects?: { id: number };
  edition_code?: string | null;
  edition_name?: string | null;
  extra_info?: string | null;
  publish_date?: string | number | null;
}

export const useSessionWizardSubmit = (
  corporateId: string | number,
  editionId: string | number,
  kind: EditionKind,
) => {
  const { trigger, isMutating } = useSWRMutation(
    `${ServicesURL.getEditions}/${kind}/${editionId}?corporateId=${corporateId}`,
    (url: string, { arg }: { arg: any }) =>
      fetcher<any>(url, MethodType.PUT, arg),
    { onError: () => {} },
  );

  const submitSession = async (
    draft: SessionDraft,
    edition: SessionWizardEdition,
    existingSessions: any[],
    editSessionId?: string | number,
  ) => {
    const normalize = (s: any) =>
      kind === "virtual" ? sessionToDraft(s, kind) : s;
    const existing = existingSessions || [];
    const merged =
      editSessionId != null
        ? existing.map((s) =>
            String(s?.id) === String(editSessionId)
              ? { ...draft, id: s?.id }
              : normalize(s),
          )
        : [...existing.map(normalize), draft];

    const payload = buildEditionPayload(
      {
        lo_id: edition.lo_id ?? edition.learning_objects?.id,
        edition_code: edition.edition_code,
        edition_name: edition.edition_name,
        extra_info: edition.extra_info,
        publish_date: edition.publish_date,
      },
      merged,
      kind,
    );

    await trigger(payload);
  };

  return { submitSession, isSubmitting: isMutating };
};
